import getWrappedUseQuery from "api/helpers/getWrappedUseQuery";

import apiClient from "../../../api-client";
import KEYS from "../keys";

export const useGetBookletProfileSetup = getWrappedUseQuery(
  KEYS.GET_ITINERARY_BOOKLET_PROFILE_SETUP,
  apiClient.ItineraryBookletsProfileSetup.get,
);
